import { useMutation } from "react-query";
import useApi from "./useApiRequest";


export const CreateCuestionarioRework = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/cuestionarios/rework/${params.id}?parte=false`, params.body, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    createCuestionarioReworkMutation: mutation.mutate,
  };
}

export const CreateCuestionariosRespuestasRework = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/cuestionarios/rework-responses/save`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    createCuestionariosRespuestasReworkMutation: mutation.mutate,
  };
}

export const UpdateCuestionarioRework = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.put(`/cuestionarios/rework/${params.id}`, params.body, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    updateCuestionarioReworkMutation: mutation.mutate,
  };
}